// src/components/DeleteConfirmationModal.js
import React, { memo, useLayoutEffect,  useRef } from "react";
import PropTypes from "prop-types";
import { Modal,  ModalBody } from "reactstrap";
import "../../styles/ModalShared.css";
const DeleteConfirmationModalComponent = ({
    isOpen,
    toggle,
    onDelete,
    deleteTitle,
    deleteMessage,
}) => {
    
    const dialogRef = useRef(null);

    // Helper to center modal based on sidebar width
    /*const centerModal = () => {
        const sidebar = document.querySelector('.sidebar');
        const dialog = dialogRef.current?.querySelector('.modal-dialog-centered');
        if (dialog) {
            const dialogRect = dialog.getBoundingClientRect();
            const windowWidth = window.innerWidth;

            if (sidebar) {
                const sidebarRect = sidebar.getBoundingClientRect();
                // Center in the space right of the sidebar
                const left = sidebarRect.width + ((windowWidth - sidebarRect.width) / 2) - (dialogRect.width / 2);
                dialog.style.position = "absolute";
                dialog.style.left = `${Math.max(left, sidebarRect.width)+50}px`;
            } else {
                // Center in the window
                const left = (windowWidth / 2) - (dialogRect.width / 2);
                dialog.style.position = "absolute";
                dialog.style.left = `${Math.max(left, 0)}px`;
            }
        }
    };*/
    useLayoutEffect(() => {
        let observer;
        if (isOpen) {
            observer = new MutationObserver(() => {
                const modalParent = document.querySelector('.modal[aria-modal="true"]')?.parentElement?.parentElement;
                if (modalParent) {
                    modalParent.style.position = "relative";
                    modalParent.style.zIndex = "99999";
                    modalParent.style.display = "block";
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
        return () => observer && observer.disconnect();
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="custom-modal" innerRef={dialogRef} >
            <ModalBody className="text-center">
                <h5 className="modal-title mb-2">{deleteTitle}</h5>
                <p className="modal-message mb-0">{deleteMessage}</p>
            </ModalBody>
            <div className="custom-footer">
                <button className="modal-btn cancel-btn" onClick={toggle}>
                    Cancel
                </button>
                <div className="divider" />
                <button className="modal-btn delete-btn" onClick={onDelete}>
                    Delete
                </button>
            </div>
        </Modal>
    );
};
DeleteConfirmationModalComponent.displayName = "DeleteConfirmationModal";

const DeleteConfirmationModal = memo(DeleteConfirmationModalComponent);

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

export default DeleteConfirmationModal;
